
// Función para formatear la fecha a dd-mm-yyyy hh:mm del formato _seconds: 1729870004, _nanoseconds: 925000000
export function formatTimestamp(timestamp: any) {
    // Convertir segundos a milisegundos
    const date = new Date(timestamp._seconds * 1000);
  
    // Obtener los componentes de la fecha
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Meses empiezan en 0
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
  
    // Formatear la fecha en dd-mm-yyyy hh:mm
    return `${day}-${month}-${year} ${hours}:${minutes}`;
  }

  export function formatTimestampOtp(timestamp: any) {
    // Convertir segundos a milisegundos
    const date = new Date(timestamp.seconds * 1000);
  
    // Obtener los componentes de la fecha
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Meses empiezan en 0
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
  
    // Formatear la fecha en dd-mm-yyyy hh:mm
    return `${day}-${month}-${year} ${hours}:${minutes}`;
  }
  